
import * as base from './environment.base';

const baseEnvironment = base.environment;
baseEnvironment.api = 'http://localhost:5268/';

export const environment = baseEnvironment;

